// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorData from "./ErrorData.bs.js";
import * as Json_decode from "@glennsl/bs-json/src/Json_decode.bs.js";
import * as Caml_js_exceptions from "@rescript/std/lib/es6/caml_js_exceptions.js";

function address(json) {
  return {
          city: Json_decode.field("city", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          country: Json_decode.field("country", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          line1: Json_decode.field("line1", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          postCode: Json_decode.field("postal_code", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json),
          state: Json_decode.field("state", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json)
        };
}

function cardDetails(json) {
  var cardBrand = Json_decode.field("brand", Json_decode.string, json);
  return {
          brand: cardBrand === "visa" ? /* Visa */0 : (
              cardBrand === "amex" ? /* Amex */2 : (
                  cardBrand === "jcb" ? /* JCB */3 : (
                      cardBrand === "mastercard" ? /* Mastercard */1 : /* Others */4
                    )
                )
            ),
          country: Json_decode.field("country", Json_decode.string, json),
          expiryMonth: Json_decode.field("exp_month", Json_decode.$$int, json),
          expiryYear: Json_decode.field("exp_year", Json_decode.$$int, json),
          fingerPrint: Json_decode.field("fingerprint", Json_decode.string, json),
          funding: Json_decode.field("funding", Json_decode.string, json),
          last4Digits: Json_decode.field("last4", Json_decode.string, json)
        };
}

function billingDetails(json) {
  return {
          address: Json_decode.field("address", address, json),
          name: Json_decode.field("name", (function (param) {
                  return Json_decode.nullable(Json_decode.string, param);
                }), json)
        };
}

function savedCard(json) {
  return {
          paymentMethodId: Json_decode.field("payment_method_id", Json_decode.string, json),
          cardDetails: Json_decode.field("card_details", cardDetails, json),
          billingDetails: Json_decode.field("billing_details", billingDetails, json)
        };
}

function savedCards(json) {
  return Json_decode.array(savedCard, json);
}

function safeDecode(json) {
  var value;
  try {
    value = Json_decode.array(savedCard, json);
  }
  catch (raw_exn){
    var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
    if (exn.RE_EXN_ID === Json_decode.DecodeError) {
      return ErrorData.Decode.safeDecodeError(json);
    }
    throw exn;
  }
  return {
          TAG: /* Ok */0,
          _0: value
        };
}

var Decode = {
  address: address,
  cardDetails: cardDetails,
  billingDetails: billingDetails,
  savedCard: savedCard,
  savedCards: savedCards,
  safeDecode: safeDecode
};

var SavedCard = {
  Decode: Decode
};

export {
  SavedCard ,
}
/* No side effect */
